import request from 'lib/request';

export interface Request {
  /**
   * blockchain
   */
  chain: string;
  /**
   * discord邀请链接
   */
  dcInviteLink: string;
  /**
   * mint时间
   */
  mintDate?: string;
  /**
   * 项目名称
   */
  name: string;
  /**
   * public price
   */
  publicPrice: number;
  /**
   * supply count
   */
  supplyCount: number;
  /**
   * 推特链接
   */
  twitterLink: string;
  /**
   * website
   */
  website: string;
  /**
   * whitelist count
   */
  whitelistCount: number;
  /**
   * whitelist price
   */
  whitelistPrice: number;
}

export interface Response {
  code: number;
  msg: string;
}

export async function projectCreate(params: Request) {
  const res = await request<Response>('/v1/project/create', {
    prefix: process.env.NEXT_PUBLIC_LUCKYBX_CLIENT_API,
    method: 'post',
    data: params,
  });

  return res.code;
}
